import React from "react";
var __jsx = React.createElement;
import { Fragment, useState } from "react";
import stl from "./ServiceCenterCard.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import ContactSVG from "../../../../../components/UiKit/UiKitSVGs/ContactSVG";
import { useTranslation } from "@i18n";
function getLocationUrl(location) {
  // Define a regex pattern to match URLs
  var urlPattern = /https?:\/\/[^\s"']+/g;

  // Search for the first URL in the provided string
  var match = location.match(urlPattern);

  // Return the URL if found, otherwise return null
  return match ? match[0] : null;
}
var ServiceCenterCard = function ServiceCenterCard(_ref) {
  var data = _ref.data;
  var _useTranslation = useTranslation(["web_service_centers"]),
    t = _useTranslation.t;
  var _useState = useState({}),
    popUpData = _useState[0],
    setPopUpData = _useState[1];
  var _useState2 = useState(false),
    ShowPopUp = _useState2[0],
    setShowPopUp = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.SCCardContainer
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.SCName
  }, t("dealership_2", {
    ns: "web_service_centers"
  }), " ", /*#__PURE__*/React.createElement("span", null, data === null || data === void 0 ? void 0 : data.dealership_name)), /*#__PURE__*/React.createElement("div", {
    className: stl.SCCity
  }, /*#__PURE__*/React.createElement("p", null, t("city_2", {
    ns: "web_service_centers"
  }), " ", /*#__PURE__*/React.createElement("span", null, data === null || data === void 0 ? void 0 : data.city)), /*#__PURE__*/React.createElement("p", null, t("branch", {
    ns: "web_service_centers"
  }), /*#__PURE__*/React.createElement("span", null, data === null || data === void 0 ? void 0 : data.branch))), /*#__PURE__*/React.createElement("hr", {
    className: "".concat(!(data !== null && data !== void 0 && data.location) ? "m-hide" : "")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.SCLocation, " ").concat(!(data !== null && data !== void 0 && data.location) ? "m-hide" : "")
  }, /*#__PURE__*/React.createElement("p", {
    className: !(data !== null && data !== void 0 && data.location) ? stl.visHidden : ""
  }, t("location", {
    ns: "web_service_centers"
  }))), /*#__PURE__*/React.createElement("div", {
    className: " ".concat(!(data !== null && data !== void 0 && data.location) ? "m-hide" : "")
  }, getLocationUrl(data === null || data === void 0 ? void 0 : data.location) && /*#__PURE__*/React.createElement("iframe", {
    title: "Service center location map",
    width: "100%",
    height: "104px",
    frameBorder: "0",
    src: getLocationUrl(data === null || data === void 0 ? void 0 : data.location)
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.SCContactCenter,
    onClick: function onClick() {
      setPopUpData(data);
      setShowPopUp(true);
    }
  }, /*#__PURE__*/React.createElement("p", null, t("contact_dealership", {
    ns: "web_service_centers"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.SCcallContainer
  }, /*#__PURE__*/React.createElement(ContactSVG, null)))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    },
    className: stl.customPopUp
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.popupContainer
  }, /*#__PURE__*/React.createElement("h3", null, t("contact_dealership", {
    ns: "web_service_centers"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.subTitle
  }, data === null || data === void 0 ? void 0 : data.dealership_name, /*#__PURE__*/React.createElement("span", {
    className: stl.pipeLine
  }, " | "), data === null || data === void 0 ? void 0 : data.city, /*#__PURE__*/React.createElement("span", {
    className: stl.pipeLine
  }, " | "), data === null || data === void 0 ? void 0 : data.branch), /*#__PURE__*/React.createElement("ul", null, data === null || data === void 0 ? void 0 : data.contact_info.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: idx
    }, item !== "" && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "tel:" + item
    }, item)));
  })))));
};
export default ServiceCenterCard;